


















import { defineComponent, PropType } from '@nuxtjs/composition-api';
import AppFavoriteIcon from '~/components/partials/App/AppFavoriteIcon.vue';
// import ProducerFavoriteButtonToast from '~/components/partials/Content/ProducerFavoriteButtonToast.vue';
import { useFavoriteButton } from '~/composables/useFavoriteButton';
// import { TOAST_TIME_OUT } from '~/constants';
import { FavoriteType } from '~/types/common/user';

type Size = 'extra-small' | 'small' | 'medium' | 'large';

export default defineComponent({
  components: {
    AppFavoriteIcon,
    // ProducerFavoriteButtonToast,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String as PropType<FavoriteType>,
      default: '',
    },
    // 生産者ID、読み物ID
    favoriteCode: {
      type: String,
      default: '',
    },
    showText: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String as PropType<Size>,
      default: 'large',
    },
  },
  setup(props) {
    // TODO: トースト仕様FIX待ち
    // const { onClickFavoriteButton, syncedActive, clicked } = useFavoriteButton(props);
    const { onClickFavoriteButton, syncedActive } = useFavoriteButton(props);

    // お気に入りボタンのトースト設定
    // const showToast = ref(false);
    // let toastTimeoutObj: number | null = null;

    // watch(syncedActive, () => {
    //   if (syncedActive.value && clicked.value) showToast.value = true;
    // });

    // // お気に入りのトーストの表示制御
    // watch(showToast, () => {
    //   if (!showToast.value) return;
    //   if (toastTimeoutObj != null) {
    //     window.clearTimeout(toastTimeoutObj);
    //   }
    //   toastTimeoutObj = window.setTimeout(() => {
    //     showToast.value = false;
    //   }, TOAST_TIME_OUT);
    // });

    return {
      syncedActive,
      onClickFavoriteButton,
      // showToast,
    };
  },
});
